import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { PayeeFormFieldComponent } from '../payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../payee-input/payee-input.directive';
import { PayeeIconButtonComponent } from '../../payee-buttons/payee-icon-button/payee-icon-button.component';

@Component({
  selector: 'payee-password-form-field',
  templateUrl: './payee-password-form-field.component.html',
  styleUrls: ['./payee-password-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeePasswordFormFieldComponent),
      multi: true,
    },
  ],
  imports: [
    PayeeFormFieldComponent,
    PayeeInputDirective,
    FormsModule,
    ReactiveFormsModule,
    PayeeIconButtonComponent,
  ],
})
export class PayeePasswordFormFieldComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private fb = inject(FormBuilder);
  private readonly destroy = new Subject<void>();

  @Input() width?: string;
  @Input() height?: string;
  @Input() placeholder = '';

  readonly showPassword = signal(false);

  readonly formControl = this.fb.control('', { nonNullable: true });

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(takeUntil(this.destroy))
      .subscribe((value) => this.onChange(value));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  onChange = (_value: string) => {};

  onTouched = () => {};

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: string | null): void {
    this.formControl.setValue(value ?? '', { emitEvent: false });
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable({ emitEvent: false });
    } else {
      this.formControl.enable({ emitEvent: false });
    }
  }
}
